/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  menuTitle: "",
  tableHeaderCellStyle: "background-color: #F5F7FA; !important;",
  tableHeaderFont10CellStyle: "background-color: #F5F7FA; font-size: 10px; !important;",
  roles: [],
  defaultUserStatus: 'OK',
  roleOptions: [{text:'광고주',value:'3'},{text:'광고대행사',value:'4'},{text:'시공사',value:'5'},{text:'이마트 점포',value:'6'},{text:'이마트 본사',value:'7'}],
  mainInfo: {
    show: false,
    roleCode: null,
  },
  spinnerVisible: false
};
